<template>
    <div>
        <div class="col-12 bg-gray2">
            <div class="h4 mb-0">
                {{ deviceDto.title }}
            </div>
        </div>
        <div class="card my-1">
            <CartPageItem
                v-for="(item, index) in deviceDto.items"
                :key="item.offerName ? item.offerName : 'cart-page-device-item-'+index"
                :dto="item"
                @remove-item-from-cart-in-progress="$emit('remove-item-from-cart-in-progress', $event)"
                @remove-item-from-cart-success="$emit('remove-item-from-cart-success', $event)"
                @remove-item-from-cart-error="$emit('remove-item-from-cart-error', $event)"
            />
        </div>
    </div>
</template>

<script>
import CartPageItem from "./CartPageItem.vue";

export default {
    name: 'CartPageDeviceContent',
    components: {
        CartPageItem,
    },
    props: {
        deviceDto: {
            type: Object,
            required: false,
            default: undefined
        }
    }
}
</script>
